import "../../pages/SwitchClient/SwitchClient";

import React from "react";
import { CircularProgress } from "@mui/material";

export interface Column<T = any> {
    header: string;
    key: string;
    render?: (value: any, row: T) => React.ReactNode;
  }

interface DataTableProps {
  columns: Column[];
  data: any[];
  loading?: boolean;
}

const DataTable: React.FC<DataTableProps> = ({
  columns,
  data,
  loading = false,
}) => {
  // Utility function to access nested properties using dot notation
  const getNestedValue = (obj: any, key: string): any => {
    const keys = key.split(".");
    return keys.reduce((acc, k) => acc?.[k], obj);
  };

  return (
    <div className="tab-page-layout-1-body">
      <div className="tab-page-layout-1-list-header config-list-header">
        {columns.map((col, index) => (
          <div className="tab-page-layout-1-li-item font-bold" key={index}>
            {col.header}
          </div>
        ))}
      </div>

      <ul
        className="tab-page-layout-1-list-section config-list-section"
        id="data-table-section"
      >
        {loading ? (
          <div className="text-center">
            <CircularProgress />
          </div>
        ) : (
          <>
            {data.length > 0 ? (
              data.map((row, rowIndex) => (
                <li
                  className="tab-page-layout-1-list-item-section config-list-item-section"
                  key={rowIndex}
                >
                  {columns.map((col, colIndex) => {
                    let value = getNestedValue(row, col.key);
                    if (col.key.includes("createdOn")) {
                      value = new Date(value).toLocaleString("en-US", {
                        weekday: "long",
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                        hour12: true,
                      });
                    }
                    return (
                      <div
                        className="tab-page-layout-1-li-item"
                        title={value}
                        key={colIndex}
                      >
                        {col.render ? col.render(value, row) : value}
                      </div>
                    );
                  })}
                </li>
              ))
            ) : (
              <div className="text-center">No data available.</div>
            )}
          </>
        )}
      </ul>
    </div>
  );
};

export default React.memo(DataTable);
